(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initAnnouncement();
    initDropdown();
    initSearchToggle();
    initTabs();
    initFaq();
    initAddToCart();
    initVariantPicker();
    initQuantitySelectors();
    initProductGallery();
  });

  // Bandeau d'annonces : rotation toutes les 4s entre les blocs saisis dans l'éditeur de thème
  function initAnnouncement() {
    var wrap = document.getElementById("announce");
    if (!wrap) return;
    var messages = wrap.querySelectorAll(".announce-msg");
    if (messages.length < 2) return;
    var index = 0;
    messages.forEach(function (el, i) {
      el.style.display = i === 0 ? "block" : "none";
    });
    setInterval(function () {
      messages[index].style.display = "none";
      index = (index + 1) % messages.length;
      messages[index].style.display = "block";
    }, 4000);
  }

  // Menus déroulants de la navigation (ex : "BIJOUX")
  function initDropdown() {
    var dropdowns = document.querySelectorAll(".dropdown");
    if (!dropdowns.length) return;
    dropdowns.forEach(function (dropdown) {
      var trigger = dropdown.querySelector(".dropdown-trigger");
      if (!trigger) return;
      trigger.addEventListener("click", function (e) {
        e.stopPropagation();
        var isOpen = dropdown.classList.toggle("open");
        trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        dropdowns.forEach(function (other) {
          if (other !== dropdown) {
            other.classList.remove("open");
            var otherTrigger = other.querySelector(".dropdown-trigger");
            if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
          }
        });
      });
    });
    document.addEventListener("click", function (e) {
      dropdowns.forEach(function (dropdown) {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove("open");
          var trigger = dropdown.querySelector(".dropdown-trigger");
          if (trigger) trigger.setAttribute("aria-expanded", "false");
        }
      });
    });
  }

  // Barre de recherche dans le header
  function initSearchToggle() {
    var btn = document.getElementById("search-toggle");
    var bar = document.getElementById("search-bar");
    if (!btn || !bar) return;
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      bar.classList.toggle("open");
      if (bar.classList.contains("open")) {
        var input = bar.querySelector("input[type=search]");
        if (input) input.focus();
      }
    });
  }

  // Onglets produits (ex : Meilleures ventes / Nouveautés)
  function initTabs() {
    document.querySelectorAll("[data-tabs]").forEach(function (group) {
      var buttons = group.querySelectorAll(".tab-btn");
      buttons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var target = btn.getAttribute("data-tab-target");
          buttons.forEach(function (b) { b.classList.remove("active"); });
          btn.classList.add("active");
          group.querySelectorAll(".product-grid").forEach(function (grid) {
            grid.classList.toggle("active", grid.id === target);
          });
        });
      });
    });
  }

  // Accordéon FAQ : un seul ouvert à la fois par groupe
  function initFaq() {
    document.querySelectorAll(".faq-list").forEach(function (list) {
      var items = list.querySelectorAll(".faq-item");
      items.forEach(function (item) {
        var btn = item.querySelector(".faq-q");
        var sign = item.querySelector(".sign");
        btn.addEventListener("click", function () {
          var willOpen = !item.classList.contains("open");
          items.forEach(function (other) {
            other.classList.remove("open");
            other.querySelector(".sign").textContent = "+";
          });
          if (willOpen) {
            item.classList.add("open");
            sign.textContent = "−";
          }
        });
      });
    });
  }

  // Ajout au panier en AJAX + mise à jour du compteur
  function initAddToCart() {
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.matches("form[data-add-to-cart-form]")) return;
      e.preventDefault();
      var submitBtn = form.querySelector("[type=submit]");
      var originalText = submitBtn ? submitBtn.textContent : "";
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Ajout...";
      }
      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          if (!res.ok) throw new Error("add-to-cart-failed");
          return res.json();
        })
        .then(function () {
          return fetch("/cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll(".cart-count").forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {
          // En cas d'échec (ex. rupture de stock), on retombe sur un envoi classique du formulaire
          form.submit();
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
    });
  }

  // Sélecteur de variantes sur la fiche produit
  function initVariantPicker() {
    var root = document.querySelector("[data-product-root]");
    if (!root) return;
    var dataEl = root.querySelector("[data-product-json]");
    if (!dataEl) return;
    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    var selects = root.querySelectorAll("[data-option-select]");
    var idInput = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-price-now]");
    var compareEl = root.querySelector("[data-price-compare]");
    var addBtn = root.querySelector("[data-add-to-cart-btn]");
    var stockNote = root.querySelector("[data-stock-note]");

    function currentSelection() {
      var values = [];
      selects.forEach(function (sel) { values.push(sel.value); });
      return values;
    }

    function findVariant(values) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return opt === values[i]; });
      });
    }

    function formatPrice(cents) {
      return (cents / 100).toFixed(2).replace(".", ",") + " €";
    }

    function update() {
      var variant = findVariant(currentSelection());
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatPrice(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatPrice(variant.compare_at_price);
          compareEl.style.display = "";
        } else {
          compareEl.style.display = "none";
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute("data-label-available") : addBtn.getAttribute("data-label-sold-out");
      }
      if (stockNote) {
        stockNote.textContent = variant.available ? "" : "Cette combinaison n'est pas disponible.";
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener("change", update);
    });
    update();
  }

  // Galerie produit : clic sur une vignette pour changer la photo principale
  function initProductGallery() {
    var main = document.querySelector("[data-main-image]");
    if (!main) return;
    document.querySelectorAll("[data-thumb-image]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var url = thumb.getAttribute("data-thumb-image");
        if (url) main.style.backgroundImage = "url('" + url + "')";
      });
    });
  }

  // Sélecteur de quantité (+ / -)
  function initQuantitySelectors() {
    document.querySelectorAll(".qty-selector").forEach(function (box) {
      var input = box.querySelector("input");
      var minus = box.querySelector("[data-qty-minus]");
      var plus = box.querySelector("[data-qty-plus]");
      if (!input) return;
      if (minus) minus.addEventListener("click", function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
      });
      if (plus) plus.addEventListener("click", function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
      });
    });
  }
})();
